export default "__VITE_ASSET__Phs7NOJV__"